<template>
  <div class="Index">
     <div class="window_bg"></div>
    <div class="haerd">
      <div class="haerd_left">
        <div class="backBtn" @click.stop.prevent="goBack">返 回</div>
        <div class="title">交通出行</div>
      </div>
      <div class="haerd_right"></div>
    </div>

    <div class="module_box">
      <div class="health" @click.stop.prevent="goLine">
        <div class="module_left w180">手机查路线</div>

        <div class="module_right_icon1 Line1">
          <div class="module_right_icon2 Line2">
            <div class="module_right_icon3 Line3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goCar">
        <div class="module_left">手机打车</div>

        <div class="module_right_icon1 Car1">
          <div class="module_right_icon2 Car2">
            <div class="module_right_icon3 Car3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goTrain">
        <div class="module_left">买火车票</div>

        <div class="module_right_icon1 Train1">
          <div class="module_right_icon2 Train2">
            <div class="module_right_icon3 Train3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goAircraft">
        <div class="module_left">买飞机票</div>

        <div class="module_right_icon1 Aircraft1">
          <div class="module_right_icon2 Aircraft2">
            <div class="module_right_icon3 Aircraft3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goCode">
        <div class="module_left w180">乘车码调用</div>

        <div class="module_right_icon1 Code1">
          <div class="module_right_icon2 Code2">
            <div class="module_right_icon3 Code3"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="prompt">温馨提示：模拟体验，非真实操作。</div>
  </div>
</template>
<script>
export default {
  name: "index",
  data() {
    return {};
  },
  created() {},
  mounted() {},
  beforeDestroy() {},

  methods: {
    async goLine() {
      this.$router.push({
        path: "/traffic/line/index",
      });
    },
    async goCar() {
      this.$router.push({
        path: "/traffic/car/index",
      });
    },
    async goVote() {
      this.$router.push({
        path: "/traffic/vote/index",
      });
    },
    //买火车票
    async goTrain() {
      this.$router.push({
        path: "/traffic/train/index",
      });
    },
    //买飞机票
    async goAircraft() {
      this.$router.push({
        path: "/traffic/aircraft/index",
      });
    },
    async goCode() {
      this.$router.push({
        path: "/traffic/code/index",
      });
    },
    async goBack() {
      this.$router.replace({
        path: "/classification",
      });
    },
  },
};
</script>

<style scoped lang="less">
.Index {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
/* 黄色 */
background: linear-gradient(180.00deg, rgb(255, 143, 51),rgb(255, 188, 92) 31.298%,rgb(255, 241, 241) 100%);
  background-size: 100% 100%;
  border-radius: 0px;
  .window_bg {
    position: absolute;
    top: -50px;
    left: -50px;
    width: 630px;
    height: 684px;
    background: url(@/assets/colorBg/window_bg.png) no-repeat center;
    background-size: 100% 100%;
  }
}
.haerd {
  padding: 40px 30px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  .haerd_left {
    position: relative;
    z-index: 1;
    .backBtn {
      cursor: pointer;
      width: 251px;
      height: 90px;
      background: url(@/assets/colorBg/backBtn.png) no-repeat center;
      background-size: 100% 100%;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 44px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      text-shadow: 0px 1px 5px rgba(200, 121, 0, 0.5);
      border-radius: 96.5px;
      box-shadow: 0px 6px 12px 1px rgba(182, 118, 118, 0.27);
    }
    .title {
      margin-top: 40px;
      // margin-left: 20px;
      font-family: SourceHanSansSC-Regular-2;
      font-weight: bold;
      font-size: 70px;
      width: 45vw;
      color: #ffffff;
      line-height: 1.2;
    }
  }
  .haerd_right {
    position: absolute;
    right: 40px;
    top: 80px;
    z-index: 0;
    width: 342px;
    height: 200px;
    background: url(@/assets/traffic/trafficIndex/trafficIndex_subscript.png)
      no-repeat center;
    background-size: 100% 100%;
  }
}

.module_box {
  // width: 100%;
  // margin: 0 40px 0;
  position: absolute;
  top: 340px;
  max-height: 910px;
  overflow-y: auto;
  padding-right: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin: 0 35px;
  .health {
    position: relative;
    overflow: hidden;
    cursor: pointer;
    display: flex;
    // flex-direction: column;
    align-items: center;
    width: 325px;
    height: 150px;
    background: #ffffff;
    border-radius: 15px;
    margin-bottom: 20px;
    margin-right: 20px;
    .module_left {
      display: flex;
      // justify-content: center;
      margin-left: 20px;
      align-items: center;
      width: 150px;
      // height: 71px;
      font-family: SourceHanSansSC-Regular-2;
      font-weight: 500;
      font-size: 33px;
      letter-spacing: 2px;
      color: #333333;
      // margin-left: 20px;
      z-index: 99;
    }
    .w180{
    width: 180px;

    }
    .module_right_icon1 {
      width: 250px;
      height: 253px;
      position: absolute;
      right: -25%;
      top: -50%;
      .module_right_icon2 {
        width: 130px;
        height: 117px;
        position: absolute;
        left: 22%;
        bottom: 4.5%;
        .module_right_icon3 {
          width: 70px;
          height: 70px;
          position: absolute;
          left: 13.5%;
          top: 23.5%;
        }
      }
    }
  }

  .Line1 {
    background: url("@/assets/colorBg/orange1.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Line2 {
    background: url("@/assets/colorBg/orange2.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Line3 {
    background: url("@/assets/traffic/trafficIndex/line.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Car1 {
    background: url("@/assets/colorBg/blue1.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Car2 {
    background: url("@/assets/colorBg/blue2.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Car3 {
    background: url("@/assets/traffic/trafficIndex/car.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Train1 {
    background: url("@/assets/colorBg/pink1.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Train2 {
    background: url("@/assets/colorBg/pink2.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Train3 {
    background: url("@/assets/traffic/trafficIndex/train.png") no-repeat center;
    background-size: 100% 100%;
  }

  .Aircraft1 {
    background: url("@/assets/colorBg/green1.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Aircraft2 {
    background: url("@/assets/colorBg/green2.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Aircraft3 {
    background: url("@/assets/traffic/trafficIndex/aircraft.png") no-repeat
      center;
    background-size: 100% 100%;
  }
  .Code1 {
    background: url("@/assets/colorBg/purple1.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Code2 {
    background: url("@/assets/colorBg/purple2.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Code3 {
    background: url("@/assets/traffic/trafficIndex/code.png") no-repeat center;
    background-size: 100% 100%;
  }

  .health:nth-child(2n) {
    margin-right: 0;
  }
}

.prompt {
  width: 100%;
  position: absolute;
  bottom: 2vh;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 30px;
  color: #666666;
  text-align: center;
}
</style>
